import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {EmOperandLabelComponent} from './operand-label.component';

@NgModule({
  imports: [CommonModule],
  declarations: [EmOperandLabelComponent],
  exports: [EmOperandLabelComponent],
})
export class EmOperandLabelModule {}
